// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionCardBackground_header__VDzCb","buttonPosition":"SectionCardBackground_buttonPosition__fkaAa"};